<template>
  <div class="chart-widget">
    <v-row class="select-row">
      <v-col cols="12" class="select-col">
        <v-select
          v-model="type"
          :items="types"
          label="Tipo"
          prepend-inner-icon="mdi-format-list-bulleted-type"
          filled
          dense
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row class="chart-row">
      <SimplePie
        v-if="chart"
        :value="chart"
        id="financial-cashflow"
      />
    </v-row>
  </div>
</template>

<script>
import SimplePie from '@/components/charts/apex/SimplePie'

import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'

export default {
  components: { SimplePie },
  mixins: [ appdata, utils ],
  props: {
    customData: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    types: [
      {
        text: 'Tipo',
        value: 'type'
      },
      {
        text: 'Categoria',
        value: 'category'
      }
    ],
    type: 'type'
  }),
  computed: {
    chart () {
      switch (this.type) {
        case 'categories':
          return this.catChart()
        case 'sub-categories':
          return this.subcatChart()
        case 'type':
          return this.typeChart()
        case 'best-sellers':
          return this.bestsellersChart()
        default:
          return []
      }
    }
  },
  methods: {
    typeChart () {
      let data = (this.get_data || {}).financial || {},
          chart = []
      Object.entries(data).forEach(([key, value]) => {
        if (value.length > 0)
          chart.push({
            title: this.lang.financial.cashflow.overview[key],
            value: value.length
          })
      })
      chart = chart.sort(function (a, b) {
        var x = a.value; var y = b.value
        return ((x > y) ? -1 : ((x < y) ? 1 : 0))
      })
      return chart
    },
    catChart () {
      // eslint-disable-next-line no-unused-vars
      let data = (this.get_data || {}).financial || {},
          chart = []

      return chart
    }
  }
}
</script>

<style lang="scss">
.chart-widget {
  #app & {
    margin: 9px;
    border-radius: 7px;
    overflow: hidden;
    .select-col {
      padding: 0px !important;
    }
  }
  #app.theme--light & {
    background: rgba(0, 0, 0, 0.02);
  }
  #app.theme--dark & {
    background: rgba(255, 255, 255, 0.05);
  }
}
</style>